// Major South African banks — used by the Bank Details wizard step and profile page.
export const SA_BANKS = [
  'ABSA', 'Capitec', 'Discovery Bank', 'First National Bank (FNB)',
  'Investec', 'Nedbank', 'Standard Bank', 'TymeBank', 'African Bank',
  'Bidvest Bank', 'Other',
];
